import { useState } from 'react';
import { useRecoilValue, useRecoilState } from 'recoil';

import { Paper, Tabs, Tab } from '@mui/material';

import { selectResultState, resultAfterUpdateColumnsState, resultBeforeUpdateColumnsState } from './States';
import SimpleTable from '@/components/table/SimpleTable';

export default function UpdateResult() {
  const [queryResult, setQueryResult] = useRecoilState(selectResultState);

  const afterUpdateColumns = useRecoilValue(resultAfterUpdateColumnsState);
  const beforeUpdateColumns = useRecoilValue(resultBeforeUpdateColumnsState);

  const [value, setValue] = useState(0);

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <Paper square>
        <Tabs
          value={value}
          indicatorColor="primary"
          textColor="primary"
          onChange={handleTabChange}
          aria-label="disabled tabs example"
        >
          <Tab label="After Update" />
          <Tab label="Before Update" />
        </Tabs>
      </Paper>
      {value === 0 && (
        <SimpleTable
          rowCount={queryResult.execution.result_after_update.length}
          rows={queryResult.execution.result_after_update}
          columns={afterUpdateColumns}
        />
      )}

      {value === 1 && (
        <SimpleTable
          rowCount={queryResult.execution.result_before_update.length}
          rows={queryResult.execution.result_before_update}
          columns={beforeUpdateColumns}
        />
      )}
    </>
  );
}
